$("nav.header__inline-menu details.mega-menu").hover(function(){
  $(this).attr('open','');
  }, function(){
  $(this).removeAttr('open');
});

/*$(".header__submenu.list-menu").hover(function(){
  $(this).parents('details').attr('open','');
  }, function(){
  $(this).parents('details').removeAttr('open');
});*/

jQuery('.tabs_top_custom_item').click(function(){
var data_item =  jQuery(this).attr('data-item');
  if ($(this).hasClass("active")) {
  } else {
jQuery('.tabs_content_custom_item').removeClass('active');
jQuery('.tabs_content_custom_item').hide();
jQuery('.tabs_top_custom_item').removeClass('active');
jQuery('.tabs_content_custom_item[data-item="'+data_item+'"]').addClass('active');
jQuery('.tabs_top_custom_item[data-item="'+data_item+'"]').addClass('active');
jQuery('.tabs_content_custom_item[data-item="'+data_item+'"]').show();
  }
});
jQuery(document).on("click", '.related_products_h2', function(event) { 
jQuery('.related_products_h2').addClass('active');
jQuery('.recently_viewed_h2').removeClass('active');
jQuery('.recently_viewed_ul').removeClass('active');
jQuery('.related_products_ul').addClass('active');
});
jQuery(document).on("click", '.recently_viewed_h2', function(event) { 
jQuery('.recently_viewed_h2').addClass('active');
jQuery('.related_products_h2').removeClass('active');
jQuery('.related_products_ul').removeClass('active');
jQuery('.recently_viewed_ul').addClass('active');
});